<template>
  <div>
    <v-card height="112px" width="200px" color="primary" class="my-2">
      <v-container fluid>
        <v-row>
          <v-avatar rounded height="25" width="200" color="primary"
                    class="text-year-week">
            {{ item.year }} KW {{ item.week }}
          </v-avatar>
        </v-row>
        <v-row>
          <v-col cols="3" class="mx-0 my-0 py-2 px-1 text-smd">SMD</v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getColor(item.smd_percent_margin)">
              <span class="percent-avatar text-subtitle-2"> {{ item.smd_plan_fte }} </span>
            </v-progress-circular>
          </v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getReverseColor(item.smd_percent)">
              <span class="percent-avatar text-subtitle-2"> {{ item.smd_percent }} </span>
            </v-progress-circular>
          </v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getReverseColor(item.smd_percent_future)">
              <span class="percent-avatar text-subtitle-2"> {{ item.smd_percent_future }} </span>
            </v-progress-circular>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="mx-0 my-0 pt-2 px-1 text-tht">THT</v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getColor(this.item.tht_percent_margin)"
                                 class="percent-avatar text-caption">
              <span class="percent-avatar text-subtitle-2"> {{ this.item.tht_plan_fte }} </span>
            </v-progress-circular>
          </v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getReverseColor(this.item.tht_percent)"
                                 class="percent-avatar text-caption">
              <span class="percent-avatar text-subtitle-2"> {{ this.item.tht_percent }} </span>
            </v-progress-circular>
          </v-col>
          <v-col cols="3" class="mx-0 my-0 py-0 px-0">
            <v-progress-circular size="35" :value="100" :color="getReverseColor(this.item.tht_percent_future)"
                                 class="percent-avatar text-caption">
              <span class="percent-avatar text-subtitle-2"> {{ this.item.tht_percent_future }} </span>
            </v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>

import BatchRunListDialog from "@/components/BatchRun/BatchRunListDialog";

export default {
  name: 'BatchRunIndicator',
  props: ['item'],
  data() {
    return {
      backColor: "purple lighten-5",
    }
  },

  components: {
    BatchRunListDialog,
  },

  methods: {
    getDateRange() {
      return this.item.date_day[0] + ' - ' + item.date_day[4]
    },
    toFixed(value) {
      return value.toFixed(0)
    },
    toPercent(value) {
      return (value * 100).toFixed(0)
    },
    getColor(percent) {
      if (percent >= 80)
        return "green accent-4"
      if (percent < 60)
        return "red accent-2"
      return "yellow accent-4"
    },
    getReverseColor(percent) {
      if (percent >= 80)
        return "red accent-2"
      if (percent < 60)
        return "green accent-4"
      return "yellow accent-4"
    }
  },

  mounted() {
  },

}
</script>

<style scoped lang="scss">
* {
  font-size: 14px;
  font-weight: bold;
}

.year-week, .deliveries {
  color: white;
}

.text-smd {
  color: lightgrey;
}

.text-tht {
  color: lightgrey;
}

.text-year-week {
  color: lightgrey;
}

.percent-avatar {
  color: white;
}

tbody td {
  text-align: right;
}

tfoot th {
  text-align: center;
}

th, td {
  padding: 0px;
}

</style>